export default "__VITE_ASSET__DmyFgolp__"